import React, { useState } from 'react';
import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { Link, NavLink } from 'react-router-dom';
import { faXTwitter, faFacebook, faLinkedin, faInstagram, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { faPhone, faHome, faLock, faFileSignature, faFileContract, faExclamationTriangle, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { EffectCreative } from 'swiper/modules';
import './Contact.css';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import swal from 'sweetalert';
import ReCAPTCHA from "react-google-recaptcha";
import CONFIG from "./config";


const PrivacyPolicy = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeTab, setActiveTab] = useState('Empower');
  const [openBioIndex, setOpenBioIndex] = useState(null);
  const [selectedMember, setSelectedMember] = useState(null);
  const [openIndex, setOpenIndex] = useState(null);
  const [directors, setDirectors] = useState([]);
  const [showAll, setShowAll] = useState(false);

  // Form data state
  const [formData, setFormData] = useState({
    fullName: '',
    fullAddress: '',
    email: '',
    phone: '',
    topic: '',
    message: '',
    consent: false,
  });

  // reCAPTCHA state
  const [captchaToken, setCaptchaToken] = useState(null);

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!captchaToken) {
      toast.error("Please verify that you are not a robot.");
      return;
    }

    const postData = {
      name: formData.fullName,
      email: formData.email,
      mobile: formData.phone,
      subject: formData.topic,
      message: formData.message,
      captcha: captchaToken,
    };

    axios
      .post(`${CONFIG.API_BASE_URL}/api/enquiries`, postData)
      .then((response) => {
        if (response.data.status === 'success') {
          swal("Success!", "Message sent successfully!", "success");

          setFormData({
            fullName: '',
            fullAddress: '',
            email: '',
            phone: '',
            topic: '',
            message: '',
            consent: false,
          });
          setCaptchaToken(null);
        } else {
          toast.error(response.data.message || 'Unknown error occurred.');
        }
      })
      .catch((error) => {
        toast.error(
          (error.response && error.response.data && error.response.data.message) || 'Error sending message.'
        );
      });
  };

  const navItems = [
    { title: 'आम्ही कोण आहोत?', path: '/leadership' },
    { title: 'बातम्या आणि ब्लॉग', path: '/news' },
    { title: 'संपर्क करा', path: '/contact' },
  ];

  return (
    <>
      <div className="page-wrapper">
        {/* Header */}
        <header className="header">
          <div className="nav-container">
            <div className="logo">
              <Link to="/">
                <img src="web.png" alt="PIR Logo" />
              </Link>
            </div>

            {/* Desktop Nav */}
            <nav className="nav-links">
              {navItems.map((item, index) => (
                <div key={index} className="nav-item">
                  <NavLink
                    to={item.path}
                    className={({ isActive }) =>
                      isActive ? "nav-button active" : "nav-button"
                    }
                  >
                    {item.title}
                  </NavLink>
                </div>
              ))}
            </nav>

            {/* Search + Title */}
            <div className="search-language" style={{ position: "relative" }}>
              <div
                style={{
                  position: "absolute",
                  top: "-19px",
                  left: "16px",
                  fontSize: "22px",
                  color: "#FF6F00",
                  fontFamily: "Mukta, sans-serif",
                  whiteSpace: "nowrap",
                  zIndex: 10,
                  pointerEvents: "none",
                }}
              >
                <span className="lokadhikar-title">महाराष्ट्र लोकाधिकार समिती</span>
              </div>

              <div className="pir-search-wrapper">{/* Search Bar */}</div>
            </div>

            {/* Hamburger Toggle */}
            <button
              className="mobile-toggle"
              onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
            >
              ☰
            </button>
          </div>

          {/* Mobile Menu */}
          {isMobileMenuOpen && (
            <div className={`mobile-menu ${isMobileMenuOpen ? "active" : ""}`}>
              {navItems.map((item, index) => (
                <Link
                  key={index}
                  className="mobile-link"
                  to={item.path}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.title}
                </Link>
              ))}
            </div>
          )}
        </header>

        <section className="contact-section">
          <div className="contact-wrapper">
            <div className="form-header">
              <h1>आमच्याशी संपर्क साधा</h1>
            </div>
            <div className="form-container">
              <div className="form-column">
                <h2>सामान्य चौकशी</h2>

                <form onSubmit={handleSubmit}>
                  <label>
                    <span style={{ color: 'red' }}>*</span> पूर्ण नाव
                    <input
                      type="text"
                      name="fullName"
                      required
                      minLength={5}
                      value={formData.fullName}
                      onChange={handleChange}
                    />
                  </label>
                  <label>
                    <span style={{ color: 'red' }}>*</span> पूर्ण पत्ता
                    <input
                      type="text"
                      name="fullAddress"
                      required
                      value={formData.fullAddress}
                      onChange={handleChange}
                    />
                  </label>
                  <label>
                    <span style={{ color: 'red' }}>*</span> फोन
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                    />
                  </label>
                  <label>
                    ईमेल
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </label>
                  <label>
                    <span style={{ color: 'red' }}>*</span> विषय
                    <select
                      name="topic"
                      required
                      value={formData.topic}
                      onChange={handleChange}
                    >
                      <option value="">एक निवडा</option>
                      {[
                        'सभासद नोंदणी',
                        'आर्थिक अन्याय',
                        'स्वत:चे अधिकार',
                        'संघटनविषयी',
                        'तांत्रिक अडचण',
                        'इतर / अन्य',
                      ].map((topic) => (
                        <option key={topic} value={topic}>
                          {topic}
                        </option>
                      ))}
                    </select>
                  </label>
                  <label>
                    <span style={{ color: 'red' }}>*</span> संदेश
                    <textarea
                      name="message"
                      rows="5"
                      required
                      value={formData.message}
                      onChange={handleChange}
                    />
                  </label>
                  <label className="checkbox">
                    <input
                      type="checkbox"
                      name="consent"
                      required
                      checked={formData.consent}
                      onChange={handleChange}
                    />
                    <span style={{ color: 'red' }}>*</span> या फॉर्मद्वारे माझा डेटा सबमिट करून, मी विनंती केलेले अपडेट्स
                    प्रदान करण्यासाठी लोकाधिकर समितीला माझा वैयक्तिक डेटा, ज्यामध्ये ईमेल आणि नाव समाविष्ट आहे,
                    वापरण्याची संमती देतो
                  </label>

                  {/* CAPTCHA */}
                  <div className="captcha-box" style={{ margin: '20px 0' }}>
                    <ReCAPTCHA
                      sitekey="6LdQS8crAAAAAJn7GD4VsT3E5e97qTm_9YRizeFP"
                      onChange={(token) => setCaptchaToken(token)}
                    />
                  </div>

                  <button type="submit">संदेश पाठवा</button>
                </form>
              </div>

              <div className="info-column">
                <h3>कार्यालयीन वेळ:</h3>
                <p>सोमवार – शुक्रवार सकाळी ९ ते संध्याकाळी ५ (EST)</p>

                {/* Email */}
                <div className="info-item">
                  <FontAwesomeIcon icon={faEnvelope} className="info-icon" />
                  <div>
                    <strong>ईमेल चौकशी</strong>
                    <br />
                    <a href="mailto:lokadhikar.in@gmail.com">lokadhikar.in@gmail.com</a>
                  </div>
                </div>

                {/* Address */}
                <div className="info-item">
                  <FontAwesomeIcon icon={faMapMarkerAlt} className="info-icon" />
                  <div>
                    <strong>ऑफिसचा पत्ता 1</strong>
                    <p>
                      महाराष्ट्र लोकाधिकार समिती कार्यालय – 23/170/20, शहापूर कोरोची रोड, हॉटेल जयहिंद समोर, शहापूर,
                      इचलकरंजी – 416 121
                    </p>

                    <strong>ऑफिसचा पत्ता 2</strong>
                    <p>
                      महाराष्ट्र लोकाधिकार समिती कार्यालय – हापूस होम्स, जामसंडे, ता. देवगड, जि. सिंधुदुर्ग, देवगड – 416
                      613
                    </p>
                  </div>
                </div>

                {/* Phone */}
                <div className="info-item">
                  <FontAwesomeIcon icon={faPhone} className="info-icon" />
                  <div>
                    <strong>फोन:</strong>
                    <br />
                    <a href="tel:+917887779899">7887779899</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <footer className="pir-footer">
          <div className="footer-container">
            <div className="footer-left">
              <img src="/web.png" alt="Logo" className="footer-logo-vertical" />
            </div>

            <div className="footer-center">
              <div className="footer-links-columns">
                <ul className="footer-links">
                  <li>
                    <a href="/privacypolicy">
                      <FontAwesomeIcon icon={faLock} /> गोपनीयता धोरण <span>(Privacy Policy)</span>
                    </a>
                  </li>
                  <li>
                    <a href="/signuppolicy">
                      <FontAwesomeIcon icon={faFileSignature} /> नोंदणी धोरण <span>(Signup Policy)</span>
                    </a>
                  </li>
                </ul>
                <ul className="footer-links">
                  <li>
                    <a href="/termsuse">
                      <FontAwesomeIcon icon={faFileContract} /> वापर अटी <span>(Terms of Use)</span>
                    </a>
                  </li>
                  <li>
                    <a href="/disclaimer">
                      <FontAwesomeIcon icon={faExclamationTriangle} /> अस्वीकृती <span>(Disclaimer)</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="footer-right">
              <div className="footer-social">
                <a href="https://x.com/Lokadhikar2005?t=n-S1KS-Ao-aj7fmOe-QRxw&s=09" target="_blank" rel="noreferrer">
                  <FontAwesomeIcon icon={faXTwitter} />
                </a>
                <a
                  href="https://www.facebook.com/groups/2151387758675095/?ref=share&mibextid=NSMWBT"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FontAwesomeIcon icon={faFacebook} />
                </a>
                <a href="https://www.linkedin.com/in/lokadhikar-samiti-0537a937a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target="_blank" rel="noreferrer">
                <FontAwesomeIcon icon={faLinkedin} /></a>
                 
                <a
                  href="https://www.instagram.com/lokadhikar.in?igsh=ZXN0bHpiYm5nMjg="
                  target="_blank"
                  rel="noreferrer"
                >
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
                <a href="https://youtube.com/@lokadhikar-2005?si=cuc0vPRI6NLxhaQs" target="_blank" rel="noreferrer">
                  <FontAwesomeIcon icon={faYoutube} />
                </a>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <p className="marathi-text">
              © २०२५ महाराष्ट्र लोकाधिकार समिती – <span className="blue-tex">सर्व हक्क राखीव</span>
            </p>
          </div>
        </footer>
      </div>

      <ul className="right-side-icons">
        <li>
          <a href="/" className="icon-link pulse-glow" title="Home">
            <FontAwesomeIcon icon={faHome} />
          </a>
        </li>
        <li>
          <a href="tel:+917887779899" className="icon pulse-glow" title="Call Us">
            <FontAwesomeIcon icon={faPhone} />
          </a>
        </li>
      </ul>
    </>
  );
};

export default PrivacyPolicy;
